export enum DefaultReportViewPreferences{
  bingcampaigns   = "defaultreportviewbingcampaigns",
  bingkeywords    = "defaultreportviewbingkeywords",
  googlecampaigns = "defaultreportviewgooglecampaigns",
  googlekeywords  = "defaultreportviewgooglekeywords",
}
